module.exports = __webpack_public_path__ + "static/media/twinkle-color-02.13de0e74.png";